import React from 'react'

import Image from '@components/Content/Image/Image'
import Wysiwyg from '@components/Content/Wysiwyg/Wysiwyg'

import { PartnerType } from '@contracts/Components/Partners'

import * as styles from './PartnersGridItem.module.scss'

interface Props {
	partner: PartnerType
}

const PartnersGridItem = (props: Props) => {
	const partnerRef = React.useRef<HTMLLIElement>(null)

	const { partner } = props

	// If hover content is clicked, toggle style "styles.active" to partner
	const handleClick = () => {
		if (partnerRef.current) {
			if (partnerRef.current.classList.contains(styles.active)) {
				partnerRef.current.classList.remove(styles.active)
			} else {
				partnerRef.current.classList.add(styles.active)
			}
		}
	}

	React.useEffect(() => {
		if (partnerRef.current) {
			partnerRef.current.addEventListener('click', handleClick)
		}

		return () => {
			if (partnerRef.current) {
				partnerRef.current.removeEventListener('click', handleClick)
			}
		}
	}, [partnerRef])

	return (
		<li ref={partnerRef} className={styles.partner}>
			<Image image={partner.featuredImage.node} altText={partner.title} />

			{partner.content && (
				<div className={styles.hoverContent}>
					<Wysiwyg content={partner.content} />
				</div>
			)}
		</li>
	)
}

export default PartnersGridItem
